import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";
// import { DRAWER_WIDTH } from "src/utils/constants";

export const MarketStyles = makeStyles((theme: Theme) =>
  createStyles({
    options: {
      width: "100%",
      margin: "5px 0px",
      overflowX: "auto",
      overflowY: "hidden",
      whiteSpace: "nowrap",
      [theme.breakpoints.up("md")]: {
        margin: "15px 0px",
      },
    },
    marketTable: {
      height: "auto",
      margin: "15px 0px",
    },
    cardSection: {
      marginBottom: "0px",
      height: "auto",
      [theme.breakpoints.down("md")]: {
        marginBottom: "15px",
      },
    },
  }),
);
